/**
 * @generated SignedSource<<8982219053f11ca5f9e6b2ca2cfb1fdf>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
export type DeMedicationType = "FREE_TEXT_MEDICATION" | "PREPARATION" | "SUBSTANCE";
export type MedicationUnit = "GTT" | "IU" | "MG" | "ML" | "PC" | "PRN" | "PUFF";
import { FragmentRefs } from "relay-runtime";
export type deMedicationFragmentInline$data = {
  readonly __typename: "de_Medication";
  readonly composition: string | null;
  readonly createdAt: string;
  readonly createdBy: string;
  readonly endDate: any | null;
  readonly eveningDosage: number;
  readonly id: string;
  readonly internalNotes: string | null;
  readonly isPermanentPrescription: boolean;
  readonly isPrescriptionRequired: boolean;
  readonly morningDosage: number;
  readonly name: string;
  readonly nightDosage: number;
  readonly noonDosage: number;
  readonly numberOfPackages: number;
  readonly patientId: string;
  readonly pharmaceuticalCentralNumber: string | null;
  readonly refuseSubstitutes: boolean;
  readonly startDate: any | null;
  readonly type: DeMedicationType;
  readonly unit: MedicationUnit;
  readonly updatedAt: string | null;
  readonly updatedBy: string | null;
  readonly usageInstructions: string | null;
  readonly " $fragmentType": "deMedicationFragmentInline";
};
export type deMedicationFragmentInline$key = {
  readonly " $data"?: deMedicationFragmentInline$data;
  readonly " $fragmentSpreads": FragmentRefs<"deMedicationFragmentInline">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "deMedicationFragmentInline"
};

(node as any).hash = "1f361670d3f8674e2fe0498105f91f98";

export default node;
